module.exports = __webpack_public_path__ + "img/fig9.23.c9fe0ab1.png";